dsf.mix(
  true,
  dsf.config,
  {
    webRoot: {
      //默认请求路径根
      default: "/",
    },
    file: {
      preViewServer: "/dsfa/",
    },
    http: {
      timeout: 60000,
    },
    //当前运行类型：project--项目
    runType: "project",
    assetsDir: "./static/",
    //默认皮肤
    setting_public_default_theme: "darkred-theme",
    //默认字体大小
    setting_public_default_size: "normal",
    //默认顶部导航栏是否为窄条
    setting_public_default_header_mini: false,
    //页面右下角是否显示设计器跳转图标
    setting_public_gotoicon: "1",
    //登录成功后进入页面地址
    setting_public_login_success_to: "./index.html",
    //登录成功后跳转页面
    setting_public_mobile_login_success_to: "./mobile-index.html",
    //登录页地址
    setting_public_pc_login_page: "./page.html#/pc/login",
    setting_public_mobile_login_page: "./mobile-index.html#/mobile/login",
    //项目logo图片地址
    setting_public_logo_image: "",
    //项目名称
    setting_public_logo_title: "",
    //默认用户头像
    setting_public_user_default_header: "./static/img/platform/defaultHeader.png",
    //菜单请求接口
    setting_public_home_menu_src: "/menu/getTree",
    //默认预览
    setting_public_file_host: "/",
    // 流程提示弹窗倒计时间，默认为3
    setting_flow_count_down_time: 3,
    // [626039]公开发布-指标数据下载-下载单元格数量控制
    setting_data_page_count_down_num: 1000000,

    setting_public_tokenkey: "dg_authorization_token",

    // map配置
    map_domainUrl: `//${location.host}/dg/chart/` /*MineMap根域名地址*/,
    map_dataDomainUrl: "//datahive.minedata.com.cn" /*MineMap矢量数据服务根域名地址*/,
    map_serverDomainUrl: "//datahive.minedata.com.cn" /* MineMap矢量数据服务新规范根域名地址 */,
    map_spriteUrl: "//minedata.com.cn/minemapapi/v2.1.0/sprite/sprite" /*MineMap底图雪碧图地址*/,
    map_serviceUrl: "//mineservice.minedata.com.cn/service/" /*MineMap后台服务根地址*/,
    map_smapServiceUrl: "//smap.minedata.com.cn/service" /*MineMap影像地图瓦片服务根地址*/,
    home_bottom_content_list: [
      {
        title: "统计法规",
        path: "",
        infos: [
          {
            text: "《统计法》",
            path: "https://www.stats.gov.cn/xxgk/zcfggz/tjfl2020/202410/t20241010_1956870.html",
          },
          {
            text: "统计法实施条例",
            path: "http://www.stats.gov.cn/gk/tjfg/xzfg/202302/t20230206_1901836.html",
          },
          {
            text: "人口普查条例",
            path: "http://www.stats.gov.cn/gk/tjfg/xzfg/202302/t20230206_1901835.html",
          },
          {
            text: "经济普查条例",
            path: "http://www.stats.gov.cn/gk/tjfg/xzfg/202302/t20230206_1901833.html",
          },
          {
            text: "统计违法违纪行为处分规定",
            path: "http://www.stats.gov.cn/gk/tjfg/gz/202302/t20230206_1901838.html",
          },
          {
            text: "统计调查证管理办法",
            path: "http://www.stats.gov.cn/gk/tjfg/gz/202302/t20230206_1901840.html",
          },
          {
            text: "涉外调查管理办法",
            path: "http://www.stats.gov.cn/gk/tjfg/gz/202302/t20230206_1901837.html",
          },
        ],
      },
      {
        title: "标准制度",
        path: "",
        infos: [
          {
            text: "国民经济行业分类",
            path: "http://www.stats.gov.cn/sj/tjbz/gmjjhyfl/202302/t20230213_1902780.html",
          },
          // {text:'国民经济核算统计报表制度',path:''},
          {
            text: "基本单位统计报表制度",
            path: "https://www.stats.gov.cn/sj/tjzd/202502/t20250211_1958700.html",
          },
          {
            text: "农林牧渔业统计调查制度",
            path: "https://www.stats.gov.cn/sj/tjzd/202502/t20250211_1958699.html",
          },
          // {text:'工业统计报表制度',path:''},
          // {text:'价格统计报表制度',path:''},
          {
            text: "更多制度>>",
            path: "https://www.stats.gov.cn/sj/tjzd/",
          },
        ],
      },
      {
        title: "统计数据生产过程",
        path: "",
        infos: [
          {
            text: "国内生产总值（GDP）",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910011.html",
          },
          {
            text: "居民消费者价格指数（CPI）",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910010.html",
          },
          {
            text: "生产者价格指数（PPI）",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910023.html",
          },
          {
            text: "工业生产增长速度",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910037.html",
          },
          {
            text: "固定资产投资",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910038.html",
          },
          {
            text: "社会消费品零售总额",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910039.html",
          },
          {
            text: "粮食产量",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910024.html",
          },
          {
            text: "城乡居民收入与支出",
            path: "https://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910025.html",
          },
        ],
      },
    ],
    home_bottom_content_list_en: [
      {
        title: "Statistical Laws and Regulations",
        path: "",
        infos: [
          {
            text: "Statistics Law of the People's Republic of China",
            path: "http://www.stats.gov.cn/english/LF/SL/201209/t20120921_27177.html",
          },
          {
            text: "Detailed Rules for Implementation of Statistics Law of People's Republic of China",
            path: "http://www.stats.gov.cn/english/LF/SR/200204/t20020402_27179.html",
          },
          {
            text: "Population Census Regulations",
            path: "http://www.stats.gov.cn/english/LF/SR/200204/t20020423_27180.html",
          },
          {
            text: "Economic Census Regulations",
            path: "http://www.stats.gov.cn/english/LF/SR/200501/t20050110_27185.html",
          },
          {
            text: "Management Method of the State Statistical Investigation Certificate",
            path: "http://www.stats.gov.cn/english/LF/SR/200208/t20020821_27183.html",
          },
          {
            text: "Management Method of the Investigation Concerning Foreign Affairs",
            path: "http://www.stats.gov.cn/english/LF/SR/200204/t20020402_27178.html",
          },
        ],
      },
      {
        title: "Classifications",
        path: "",
        infos: [
          {
            text: "Classifications Explanation of the Division Standard of Large/Medium/Small Sized Industrial Enterprises",
            path: "http://www.stats.gov.cn/english/ClassificationsMethods/Classifications/200210/t20021016_72368.html",
          },
          {
            text: "Division standard of large/medium/small sized enterprises",
            path: "http://www.stats.gov.cn/english/ClassificationsMethods/Classifications/200210/t20021016_72367.html",
          },
          {
            text: "Oversized industrial enterprises division standard",
            path: "http://www.stats.gov.cn/english/ClassificationsMethods/Classifications/200211/t20021118_72366.html",
          },
          {
            text: "Classification Standard of Large/Medium-sized Non-industrial Construction Projects",
            path: "http://www.stats.gov.cn/english/ClassificationsMethods/Classifications/200211/t20021118_72365.html",
          },
          {
            text: "More Classifications>>",
            path: "http://www.stats.gov.cn/english/ClassificationsMethods/Classifications/",
          },
        ],
      },
      {
        title: "Production Process of Statistical Data",
        path: "",
        infos: [
          {
            text: "Gross Domestic Product",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910018.html",
          },
          {
            text: "Consumer Price Index",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910019.html",
          },
          {
            text: "Producer Price Index",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910033.html",
          },
          {
            text: "Grain Production",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910032.html",
          },
          {
            text: "Income and Expenditure of Urban and Rural Households",
            path: "http://www.stats.gov.cn/zs/tjwh/spdb/202302/t20230217_1910034.html",
          },
        ],
      },
      {
        title: "Telephone",
        path: "",
        infos: [
          { text: "010-68576320", path: "" },
          { text: "Mon - Fri, 8:00-11:30, 13:00-17:00", path: "" },
          {
            text: "©2014 National Bureau of Statistics of China, All Rights Reserved.",
            path: "",
          },
          { text: "京ICP备05034670号-2", path: "" },
          {
            text: "Address: No 57, YueTan Nan St., Xicheng, Beijing,100826",
            path: "",
          },
        ],
      },
    ],
  },
  window.$$serverConfig ? window.$$serverConfig : {},
  // (function () {
  //   if (window.$$serverConfig.setting_public_config_js) {
  //     try {
  //       return JSON.parse(window.$$serverConfig.setting_public_config_js.trim())
  //     }
  //     catch (ex) {
  //       return {}
  //     }
  //   }
  //   return {}
  // })(),
  window.$$config ? window.$$config : {},
);
window.$$webRoot = dsf.config.webRoot;
